export enum AUDIO_PRELOAD_MODE {
    auto = 'auto',
    metadata = 'metadata',
    none = 'none',
}
